import Inheritable from '@nxsys/components/Inheritable';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Form, Switch } from 'antd';
import React from 'react';
import type { PayrollFinanceSectionProps } from './types';
import { useSelector } from 'react-redux';
import { AppState } from '@nxsys/store';
import { IRELAND } from '@nxsys/store/constants/keys';

const RestrictedHoursSection: React.FC<PayrollFinanceSectionProps> = ({
  form,
  watchValues,
  visibility,
}) => {
  const { messages } = useTypedIntl();
  const { payrollCountry } = useSelector((state: AppState) => state.appStore);

  // NX-5228: the 20-hour restricted-hours check only runs for UK payrolls
  // (getIsRestrictedHoursValidation, Tier 4 student visa only).
  if (!visibility.restrictedHours || payrollCountry === IRELAND) return null;

  return (
    <div className="pt-6">
      <Form.Item
        name={['restrictedHours', 'isRestrictedHours']}
        wrapperCol={{ span: 24 }}
      >
        <Inheritable<boolean>
          label={`${messages['common.restrictedHours']}?`}
          tooltip={messages['common.restrictedHoursTooltip']}
          name={['restrictedHours', 'isRestrictedHours']}
          value={watchValues?.restrictedHours?.isRestrictedHours}
          inheritedValue={false}
          form={form}
        >
          {({ value, onChange, disabled }) => (
            <Switch
              checked={value ?? false}
              disabled={disabled}
              onChange={onChange}
            />
          )}
        </Inheritable>
      </Form.Item>
    </div>
  );
};

export default RestrictedHoursSection;
